export default "/images/534c66aa3f8a12506983189e66c2b708.avif";